
<div class="card-list">
    <div class="card-list-header">
        <h4>{{header}}</h4>
        <button (click)="toggle()">
            <ico [size]="24" ico="expand_less_big_24"  [rotate]="show?0:180"></ico>
        </button>
    </div>
    <div *ngIf="show" class="card-list-html" [innerHtml]="html"></div>
</div>
